const checkURL = window.location.href;

if (checkURL.includes("stokke")) {
    document.addEventListener("DOMContentLoaded", function () {
        const textBlocks = document.querySelectorAll(".convx__stokke_text");

    function checkAndUpdateButtonVisibility() {
        textBlocks.forEach((block) => {
            // Create clone to measure full height
            const clone = block.cloneNode(true);
            clone.style.visibility = "hidden";
            clone.style.position = "absolute";
            clone.style.height = "auto";
            clone.style.webkitLineClamp = "unset";
            clone.style.display = "block";
            clone.classList.remove("expanded");

            document.body.appendChild(clone);

            const lineHeight = parseFloat(getComputedStyle(block).lineHeight);
            const maxHeight = lineHeight * 4; // Changed to 4 lines to match CSS

            // Find existing button container if it exists
            let existingBtnContainer = block.nextElementSibling;
            if (existingBtnContainer && !existingBtnContainer.classList.contains('seeMoreStokke')) {
                existingBtnContainer = null;
            }

            if (clone.offsetHeight > maxHeight) {
                if (!existingBtnContainer) {
                    // Create container div
                    const btnContainer = document.createElement("div");
                    btnContainer.className = "logo__seeMoreButton seeMoreStokke";
                    
                    // Create button and add it to container
                    const btn = document.createElement("button");
                    btn.className = "logo__see-more-btn";
                    btn.innerText = "View More";
                    btnContainer.appendChild(btn);

                    // Add click event to the button
                    btn.addEventListener("click", function () {
                        block.classList.toggle("expanded");
                        btn.innerText = block.classList.contains("expanded")
                            ? "View Less"
                            : "View More";
                    });

                    // Insert the container after the block
                    block.after(btnContainer);
                }
            } else if (existingBtnContainer) {
                // Remove button if text doesn't exceed max height
                existingBtnContainer.remove();
            }

            document.body.removeChild(clone);
        });
    }

    // Initial check
    checkAndUpdateButtonVisibility();

    // Recheck on window resize for mobile responsiveness
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(checkAndUpdateButtonVisibility, 250);
        });
    });
}
  